

import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import { Profile } from 'src/app/models/Profile';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-catalog-dialog',
  templateUrl: './catalog-dialog.component.html',
  styleUrls: ['./catalog-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],
})
export class CatalogDialogComponent implements OnInit {

  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.

  invalidPredTask: boolean = false;
  invalidOtherTaskName: boolean = false;
  invalidCompLow: boolean = false;
  invalidCompMid: boolean = false;
  invalidCompHi: boolean = false;
  invalidTshirtXS: boolean = false;
  invalidTshirtS: boolean = false;
  invalidTshirtM: boolean = false;
  invalidTshirtL: boolean = false;
  invalidTshirtXL: boolean = false;
  invalidTshirtXXL: boolean = false;

  errorPredTask: string = '';
  errorOtherTaskName: string = '';
  errorCompLow: string = '';
  errorCompMid: string = '';
  errorCompHi: string = '';
  errorTshirtXS: string = '';
  errorTshirtS: string = '';
  errorTshirtM: string = '';
  errorTshirtL: string = '';
  errorTshirtXL: string = '';
  errorTshirtXXL: string = '';


  originalName: string = '';


  isUsers: boolean = false;
  isProjectType: boolean = false;
  isConfigurationType: boolean = false;
  isMacroActivities: boolean = false;
  isMacroActivitiesType: boolean = false;
  showMacro: boolean = false;
  filteredMacro: any[] = [];

  formGroup1: any;

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type.
  otherTypeMacro = false;

  riskInputEffort: any;

  isActionType: boolean = false;

  list: any;
  listInDB: any;
  isEdit = false;
  profiles: Profile[] = [];
  centers: string[] = [];
  filteredProfiles: Profile[] = [];

  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<CatalogDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private infoBar: InfoBarWithStatusService,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.items = [
      { name: this.variables?.implementation },
      { name: 'Review' },
      { name: this.variables?.other }
    ];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

      this.items = [
        { name: this.variables?.implementation },
        { name: 'Review' },
        { name: this.variables?.other }
      ];

      this.effort = this.variables?.hours;
    });

    //Add default values to predefined list
    let list = this.local_data.list;
    this.listInDB = this.local_data.listInDB;

    this.isEdit = this.local_data.isEdit
    this.profiles = Array.isArray(this.local_data.profiles) ? this.local_data.profiles : [];


    if (list && !this.local_data?.isMacroActivities && !list.some((item: any) => item['name'] === this.variables.other)) this.local_data.list.push({ name: this.variables.other })

    //Check to see if the value selected from the predefined list is 'Outro', meaning that the user will add a custom input and the form should be displayed to the user.


    if (this.isEdit) {
      this.originalName = this.data.item.name;

      var fControl;
      if (this.data.item.name == this.variables.createUserInterfaces ||
        this.data.item.name == this.variables.developRestApis ||
        this.data.item.name == this.variables.developSoapApis ||
        this.data.item.name == this.variables.createRelationalDatabase ||
        this.data.item.name == this.variables.createNonRelationalDatabase ||
        this.data.item.name == this.variables.createTableDatabase ||
        this.data.item.name == this.variables.createProceduresTrigers ||
        this.data.item.name == this.variables.createIntegrationDatabases) {
        this.otherType = false;
        fControl = { 'value': this.data.item.name, disabled: true };
      }
      else {
        fControl = { 'value': this.variables.other, disabled: true };
        this.otherType = true;
      }
      this.formGroup1 = this._formBuilder.group({
        predTaskCtrl: [fControl, Validators.required],
        otherTaskNameCtrl: [this.local_data.item.name, Validators.required],
        compLowCtrl: [this.local_data.item.complexityLow, Validators.required],
        compMidCtrl: [this.local_data.item.complexityMedium, Validators.required],
        compHiCtrl: [this.local_data.item.complexityHigh, Validators.required],
        detailsLowCtrl: [this.local_data.item.detailsLow],
        detailsMedCtrl: [this.local_data.item.detailsMedium],
        detailsHighCtrl: [this.local_data.item.detailsHigh],
        tshirtXSCtrl: [this.local_data.item.tshirtXS, Validators.required],
        tshirtSCtrl: [this.local_data.item.tshirtS, Validators.required],
        tshirtMCtrl: [this.local_data.item.tshirtM, Validators.required],
        tshirtLCtrl: [this.local_data.item.tshirtL, Validators.required],
        tshirtXLCtrl: [this.local_data.item.tshirtXL, Validators.required],
        tshirtXXLCtrl: [this.local_data.item.tshirtXXL, Validators.required],
        profileCtrl: [this.local_data.item.profileId || ''],
        centerCtrl: [''],
      });
    }
    else {
      this.formGroup1 = this._formBuilder.group({
        predTaskCtrl: ['', Validators.required],
        predTaskCtrlUser: ['', Validators.required],
        otherTaskNameCtrl: ['', Validators.required],
        compLowCtrl: ['', Validators.required],
        compMidCtrl: ['', Validators.required],
        compHiCtrl: ['', Validators.required],
        eighthCtrl: ['', Validators.required],
        detailsLowCtrl: [''],
        detailsMedCtrl: [''],
        detailsHighCtrl: [''],
        tshirtXSCtrl: ['0.8', Validators.required],
        tshirtSCtrl: ['1.6', Validators.required],
        tshirtMCtrl: ['2.4', Validators.required],
        tshirtLCtrl: ['4.0', Validators.required],
        tshirtXLCtrl: ['6.4', Validators.required],
        tshirtXXLCtrl: ['10.4', Validators.required],
        profileCtrl: [''],
        centerCtrl: [''],

      });
    }

    this.centers = [...new Set(this.profiles.map(p => p.center).filter(c => !!c))] as string[];
    this.filteredProfiles = this.profiles;

    if (this.isEdit && this.local_data.item.profileId) {
      const existingProfile = this.profiles.find(p => p.id === this.local_data.item.profileId);
      if (existingProfile?.center) {
        this.formGroup1.get('centerCtrl')?.setValue(existingProfile.center);
        this.filteredProfiles = this.profiles.filter(p => p.center === existingProfile.center);
      } else {
        this.filteredProfiles = this.profiles;
      }
    } else {
      this.filteredProfiles = this.profiles;
    }

    if (this.local_data.effort) this.effort = this.local_data.effort;

    this.isActionType = this.local_data.isActionType !== undefined ? this.local_data.isActionType : false;


    this.formGroup1.get("predTaskCtrl").valueChanges.subscribe((result: any) => {
      if (result === this.variables.other) {
        this.otherType = true;
        this.formGroup1.get('fourthCtrl').setValue('');
      }
      else {
        this.otherType = false;
      }
      if (result.predTaskCtrl) this.invalidPredTask = false;
    });

  }

  validateUniqueName() {

    const nameToValidate = this.otherType
      ? this.formGroup1.get('otherTaskNameCtrl')?.value?.trim()
      : this.formGroup1.get('predTaskCtrl')?.value?.trim();


    this.listInDB.some((item: any) => item.name === nameToValidate);

    return !this.listInDB.some((item: any) =>
      item.name === nameToValidate &&
      (!this.isEdit || item.name !== this.originalName) // exclude current user
    );
  }

  cleanErrors() {
    this.invalidPredTask = false;
    this.invalidOtherTaskName = false;
    this.invalidCompLow = false;
    this.invalidCompMid = false;
    this.invalidCompHi = false;
    this.invalidTshirtXS = false;
    this.invalidTshirtS = false;
    this.invalidTshirtM = false;
    this.invalidTshirtL = false;
    this.invalidTshirtXL = false;
    this.invalidTshirtXXL = false;

    this.errorPredTask = '';
    this.errorOtherTaskName = '';
    this.errorCompLow = '';
    this.errorCompMid = '';
    this.errorCompHi = '';
    this.errorTshirtXS = '';
    this.errorTshirtS = '';
    this.errorTshirtM = '';
    this.errorTshirtL = '';
    this.errorTshirtXL = '';
    this.errorTshirtXXL = '';
  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;
    this.cleanErrors()

    /*
      Check if all the inputs have been filled.
    */
    if (formGroup.predTaskCtrl === '') {
      this.invalidPredTask = true;
      this.errorPredTask = this.variables.chooseProjectType;
      valid = false;
    }
    if ((formGroup.otherTaskNameCtrl === '' || formGroup.otherTaskNameCtrl === undefined) && this.otherType === true) {
      this.invalidOtherTaskName = true;
      this.errorOtherTaskName = this.variables.insertName;
      valid = false;
    }

    if (formGroup.otherTaskNameCtrl?.trim()) {
      if (!this.validateUniqueName()) {
        this.invalidOtherTaskName = true;

        if (!this.isEdit) {
          this.errorOtherTaskName = this.variables.snackBarErrorAddAction;
        }
        else {
          this.errorOtherTaskName = this.variables.snackBarErrorEditAction;
        }

        valid = false;
      }
    }

    if (formGroup.predTaskCtrl?.trim()) {
      if (!this.validateUniqueName()) {
        this.invalidPredTask = true;
        this.errorPredTask = this.variables.snackBarErrorAddAction;
        valid = false;
      }
    }



    if ((formGroup.compLowCtrl < 0 || !formGroup.compLowCtrl)) {
      this.invalidCompLow = true;
      this.errorCompLow = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.compMidCtrl < 0 || !formGroup.compMidCtrl)) {
      this.invalidCompMid = true;
      this.errorCompMid = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.compMidCtrl <= formGroup.compLowCtrl)) {
      this.invalidCompMid = true;
      this.errorCompMid = this.variables.numberGreaterLower;
      valid = false;
    }
    if ((formGroup.compHiCtrl < 0 || !formGroup.compHiCtrl)) {
      this.invalidCompHi = true;
      this.errorCompHi = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.compHiCtrl <= formGroup.compMidCtrl)) {
      this.invalidCompHi = true;
      this.errorCompHi = this.variables.numberGreaterMid;
      valid = false;
    }
    if ((formGroup.tshirtXSCtrl <= 0 || !formGroup.tshirtXSCtrl)) {
      this.invalidTshirtXS = true;
      this.errorTshirtXS = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.tshirtSCtrl <= 0 || !formGroup.tshirtSCtrl)) {
      this.invalidTshirtS = true;
      this.errorTshirtS = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.tshirtMCtrl <= 0 || !formGroup.tshirtMCtrl)) {
      this.invalidTshirtM = true;
      this.errorTshirtM = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.tshirtLCtrl <= 0 || !formGroup.tshirtLCtrl)) {
      this.invalidTshirtL = true;
      this.errorTshirtL = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.tshirtXLCtrl <= 0 || !formGroup.tshirtXLCtrl)) {
      this.invalidTshirtXL = true;
      this.errorTshirtXL = this.variables.numberGreaterThenZero;
      valid = false;
    }
    if ((formGroup.tshirtXXLCtrl <= 0 || !formGroup.tshirtXXLCtrl)) {
      this.invalidTshirtXXL = true;
      this.errorTshirtXXL = this.variables.numberGreaterThenZero;
      valid = false;
    }



    if (formGroup.predTaskCtrlUser) {
      this.local_data.userName = formGroup.predTaskCtrlUser;
    }

    if (!formGroup.otherTaskNameCtrl) {
      this.local_data.name = formGroup.predTaskCtrl;
    }
    else {
      this.local_data.name = formGroup.otherTaskNameCtrl;
    }

    if (formGroup.thirdCtrl) {
      this.local_data.complexity = formGroup.thirdCtrl;
    }

    if (formGroup.fourthCtrl) {
      this.local_data.risk = formGroup.fourthCtrl;
    }
    if (formGroup.compLowCtrl) {
      this.local_data.complexityLow = parseFloat(parseFloat(formGroup.compLowCtrl).toFixed(2));
    }
    if (formGroup.compMidCtrl) {
      this.local_data.complexityMedium = parseFloat(parseFloat(formGroup.compMidCtrl).toFixed(2));
    }
    if (formGroup.compHiCtrl) {
      this.local_data.complexityHigh = parseFloat(parseFloat(formGroup.compHiCtrl).toFixed(2));
    }


    if (formGroup.detailsLowCtrl) {
      this.local_data.detailsLowCtrl = formGroup.detailsLowCtrl;
    }
    if (formGroup.detailsMedCtrl) {
      this.local_data.detailsMedCtrl = formGroup.detailsMedCtrl;
    }
    if (formGroup.detailsHighCtrl) {
      this.local_data.detailsHighCtrl = formGroup.detailsHighCtrl;
    }
    if (formGroup.tshirtXSCtrl) {
      this.local_data.tshirtXS = formGroup.tshirtXSCtrl;
    }
    if (formGroup.tshirtSCtrl) {
      this.local_data.tshirtS = formGroup.tshirtSCtrl;
    }
    if (formGroup.tshirtMCtrl) {
      this.local_data.tshirtM = formGroup.tshirtMCtrl;
    }
    if (formGroup.tshirtLCtrl) {
      this.local_data.tshirtL = formGroup.tshirtLCtrl;
    }
    if (formGroup.tshirtXLCtrl) {
      this.local_data.tshirtXL = formGroup.tshirtXLCtrl;
    }
    if (formGroup.tshirtXXLCtrl) {
      this.local_data.tshirtXXL = formGroup.tshirtXXLCtrl;
    }

    this.local_data.profileId = formGroup.profileCtrl || null;


    //Pass data
    if (valid) {
      this.dialogRef.close({ data: this.local_data })
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);

    };
  }

  validateDecimal(event: any): void {
    const value = event.target.value;
    if (value.includes('.')) {
      const decimalPart = value.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        event.target.value = parseFloat(value).toFixed(2);
      }
    }
  }

  onCenterChange(center: string): void {
    if (center) {
      this.filteredProfiles = this.profiles.filter(p => p.center === center);
    } else {
      this.filteredProfiles = this.profiles;
    }
    this.formGroup1.get('profileCtrl')?.setValue('');
  }
}
